import { ReactNode } from 'react'
import { useTranslation } from 'next-i18next'

import PanelElementContainer from '~/panels/components/PanelElementContainer'
import { formatHours } from '~/panels/utils/panels.utils'
import RenewablePackages from '~/panels/components/RenewablePackages'

export default function StudentPackages({
  header,
  hoursSpent,
  packages,
  totalHours,
}: {
  header: ReactNode
  hoursSpent: number | undefined
  packages: string[]
  totalHours: number | undefined
}): React.ReactElement {
  const { t } = useTranslation(['generics', 'studentPanel'])

  return (
    <PanelElementContainer header={header} headerIcon="hom-graduation-cap-circle">
      <div>
        <RenewablePackages />
        <hr className="mt-5 mb-1 text-purple-medium" />
        <p className="text-black-light text-xxs tracking-[0.075em] font-semibold">
          {t('studentPanel:purchaseHistory')}
        </p>
        {packages.map((elem, idx) => (
          <div className="my-2 p-2 border-2 border-blue-iris rounded text-center" key={`${elem}-${idx}`}>
            <span className="text-xs font-medium text-blue-iris">{elem}</span>
          </div>
        ))}
        {typeof hoursSpent === 'number' && typeof totalHours === 'number' && (
          <div className="text-xxs">
            <span className="font-semibold">
              <span className="text-green-checkmark">{formatHours(hoursSpent)}</span>/{formatHours(totalHours)}
            </span>
            <span>&nbsp;</span>
            <span>{t('studentPanel:sessionsCompleted').toLowerCase()}</span>
          </div>
        )}
      </div>
    </PanelElementContainer>
  )
}
